import styled from 'styled-components';
import { color, type ColorProps } from 'styled-system';

export const MobileWrapper = styled.div<{ inSearchRoute: boolean }>`
	position: relative;
	display: flex;
	align-items: center;
	width: ${props => (props.inSearchRoute ? '100%' : 'auto')};
	padding: 12px 0;
	z-index: 1;

	.favorite-games-icon {
		margin-left: 6px;

		&--active {
			background-color: var(--submenu-item-bg-active);
		}
	}
`;

export const SearchInputField = styled.input<ColorProps>`
	&:focus {
		outline: none;
	}
	background-color: rgba(var(--base-08), 1);
	appearance: none;
	-webkit-appearance: none;
	color: var(--search-text-small, rgba(var(--base-02), 1));
	font: var(--search-text-font, var(--h4-regular));
	font-size: 15px;
	padding: 0 0 0 36px;
	width: 100%;
	height: 36px;
	line-height: 36px;
	border-radius: var(--search-input-border-radius, 3px);
	&::placeholder {
		color: var(--search-text, rgba(var(--base-02), 1));
		opacity: 0.6; /* Needed for Firefox */
	}
	&::-ms-input-placeholder {
		color: var(--search-text, rgba(var(--base-02), 1));
	}
	&::-webkit-search-cancel-button {
		display: none;
	}
	${color}
`;

export const MobileInputWithIconsWrapper = styled.div`
	width: 100%;
	position: relative;
	border-radius: 3px;
	overflow: hidden;
`;

export const SearchResultsMoreButton = styled.button`
	margin: auto;
	border: 0;
	background-color: transparent;
	color: var(--search-results-more);
`;

export const SearchResultsCancelButton = styled.button`
	border: 0;
	color: var(--search-cancel-color, var(--search-text));
	font: var(--search-cancel-font);
	margin-left: 12px;
	outline: 0;
	padding: 0;
	background-color: transparent;
	white-space: nowrap;
`;
